import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  removeUpdatingVisaAdded,
  removeVisaFromProposal,
  setVisaUpdatingInProposal,
  updatingVisaAdded,
} from "../../actions/proposal";
import { openModal } from "../../actions/ui";
import { images } from "../../constants";
import { numberNotation } from "../../helper/numberStructure";
import ModalProposal from "../Modals/ModalProposal";

import "./VisaCard.scss";
import VisaCardForEditing from "./VisaCardForEditing";

const VisaCard = ({ visaSelected }) => {
  const { _id, name, visafee, extrafee, subname, quantity } =
    visaSelected;

  const dispatch = useDispatch();

  const { modalOpen } = useSelector((state) => state.ui);
  const { updatingVisa } = useSelector((state) => state.proposals);

  const handleEditVisa = (visa) => {
    dispatch(openModal());
    dispatch(updatingVisaAdded());
    dispatch(setVisaUpdatingInProposal(visa));
  };
  const handleDeleteVisa = (visaId) => {
    dispatch(removeVisaFromProposal(visaId));
  };
  return (
    <div className="visa-card">
      <div className="visa-card__wrapp">
        <div className="card__heading">
          <div className="card__heading--image">
            <img src={images.logoVisa} alt="visa" />
          </div>
          <div className="card__heading--title">
            <div>
              <p className="title-gray-black-18">{name}</p>
              <p className="paragraph-gray-reg-16">{subname}</p>
            </div>
          </div>
          <div className="card__heading--button">
            <button onClick={() => handleEditVisa(visaSelected)}>
              <img src={images.IconEdit} alt="" />
            </button>

            <button onClick={() => handleDeleteVisa(_id)}>
              <img src={images.IconDelete} alt="" />
            </button>
          </div>
        </div>

        <div className="card__prices">
          <div className="card__prices--item">
            <p className="paragraph-gray-reg-14">Quantity</p>
            <p className="title-gray-bold-14">{quantity}</p>
          </div>
          <div className="card__prices--item">
            <p className="paragraph-gray-reg-14">Visa Fee</p>
            <p className="title-gray-bold-14">A${visafee}</p>
          </div>
          <div className="card__prices--item">
            <p className="paragraph-gray-reg-14">Extra Fee</p>
            <p className="title-gray-bold-14">A${extrafee}</p>
          </div>
          <div className="card__prices--item">
            <p className="paragraph-gray-reg-14">Total Fee</p>
            <p className="title-gray-black-18">
              A${numberNotation(visafee * quantity + extrafee)}
            </p>
          </div>
        </div>
      </div>
      {modalOpen && updatingVisa && (
        <ModalProposal clean={removeUpdatingVisaAdded}>
          <VisaCardForEditing />
        </ModalProposal>
      )}
    </div>
  );
};

export default VisaCard;
